export const DChartAxisPosition = wcardinal.ui.DChartAxisPosition;